module.exports = __webpack_public_path__ + "static/media/placeholder.aeca4d57.svg";